import './styles.scss'
export default function ErrorLabel({
  children,
}: {
  children: React.ReactNode
}) {
  return <small className="error">{children}</small>
}
